// extracted by mini-css-extract-plugin
export var arrows = "_8p-6";
export var decrementer = "_8p-a";
export var disabled = "_8p-4";
export var error = "_8p-1";
export var hiddenText = "_8p-b";
export var incrementer = "_8p-9";
export var input = "_8p-8";
export var inputWrapper = "_8p-0";
export var leadingIcon = "_8p-c";
export var readonly = "_8p-3";
export var regular = "_8p-7";
export var small = "_8p-5";
export var warning = "_8p-2";